const API_V1_PREFIX = '/api/v1';
const ABSOLUTE_HTTP_URL_PATTERN = /^https?:\/\//i;
const ABSOLUTE_WS_URL_PATTERN = /^wss?:\/\//i;

let runtimeApiBaseUrl: string | null = null;

function ensureLeadingSlash(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}

function normalizeBaseUrl(baseUrl?: string | null): string | null {
  const trimmed = baseUrl?.trim();
  return trimmed ? trimmed.replace(/\/+$/, '') : null;
}

function resolveRuntimePath(baseUrl: string, path: string): string {
  const normalizedPath = ensureLeadingSlash(path);

  if (/\/api\/v1$/i.test(baseUrl)) {
    return `${baseUrl}${normalizedPath.replace(/^\/api\/v1/i, '')}`;
  }

  if (/\/api$/i.test(baseUrl)) {
    return `${baseUrl}${normalizedPath.replace(/^\/api/i, '')}`;
  }

  return `${baseUrl}${normalizedPath}`;
}

function toAbsoluteHttpUrl(url: string): string {
  if (ABSOLUTE_HTTP_URL_PATTERN.test(url) || typeof window === 'undefined') {
    return url;
  }

  return new URL(url, window.location.origin).toString();
}

export function setRuntimeApiBaseUrl(baseUrl?: string | null): void {
  runtimeApiBaseUrl = normalizeBaseUrl(baseUrl);
}

export function getRuntimeApiBaseUrl(): string | null {
  return runtimeApiBaseUrl;
}

export function getConfiguredApiBaseUrl(): string {
  return runtimeApiBaseUrl
    ? resolveRuntimePath(runtimeApiBaseUrl, API_V1_PREFIX)
    : API_V1_PREFIX;
}

export function resolveApiUrl(path: string): string {
  if (ABSOLUTE_HTTP_URL_PATTERN.test(path)) {
    return path;
  }

  const normalizedPath = ensureLeadingSlash(path);
  return runtimeApiBaseUrl
    ? resolveRuntimePath(runtimeApiBaseUrl, normalizedPath)
    : normalizedPath;
}

export function resolveWebSocketUrl(path: string = `${API_V1_PREFIX}/chat/ws`): string {
  if (ABSOLUTE_WS_URL_PATTERN.test(path)) {
    return path;
  }

  const httpUrl = ABSOLUTE_HTTP_URL_PATTERN.test(path)
    ? path
    : toAbsoluteHttpUrl(resolveApiUrl(path));

  if (!ABSOLUTE_HTTP_URL_PATTERN.test(httpUrl)) {
    return httpUrl;
  }

  const wsUrl = new URL(httpUrl);
  wsUrl.protocol = wsUrl.protocol === 'https:' ? 'wss:' : 'ws:';
  return wsUrl.toString();
}
